// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TeamMembersSection-module--wrapper--o56Sk";
export var decorator = "TeamMembersSection-module--decorator--D9uYG";
export var inner = "TeamMembersSection-module--inner--NUX3b";
export var sectionTitle = "TeamMembersSection-module--sectionTitle--cfuza";